import { combineReducers } from "redux";
import { userReducer } from "./user/reducers";
import { reducer as formReducer } from "redux-form";
import { orgReducer } from "./orgs/reducers";
import { RouteChange } from "./route/reducers";
import { Apps } from "./apps/reducers";
import { FormsReducers } from "./forms/reducers";
import { formJsonCreation } from "./formCreation/reducers";
import { Toast } from './toast/reducers'
import { productReducer } from './product/reducers'
import { contextMenuReducer } from './contextMenu/reducers'
import { SoloReducer } from './solo/reducers';
import { assetsReducer } from "./assets/reducers";
import { marketPlaceFunctionReducer } from './marketplaceFunction/reducers';
import common from './common/reducers';
import { uiStateReducer } from "./uiState/reducers";

import { formJsonReducer } from "./formCreation_v2/reducer"
import {saveTem} from "./table/reducers";
import { contextMenuReducerv2 } from "./contextMenuv2/reducers";
import {saveLoadedSegmentId} from "./segmentControl/reducers";
import { tarsReducer } from "./tars";
import { staticAssetReducer } from "./static-assets/reducer"
import { I18N } from "./i18n/reducers";
import { saveLoadedWizardStepsId } from "./wizard/reducers";
import { onboardingReducer } from "./onboarding/reducers";
import { widgetIdReducer } from "./widgetsID/reducer";


const appReducer:any = combineReducers({
  user: userReducer,
  org: orgReducer,
  breadcrumb: RouteChange,
  form: formReducer,
  forms: FormsReducers,
  formcreation: formJsonCreation,
  apps: Apps,
  toast: Toast,
  product: productReducer,
  contextMenu: contextMenuReducer,
  common: common,
  solo: SoloReducer,
  saveTem: saveTem,
  assets: assetsReducer,
  uiState: uiStateReducer,
  marketplaceFunction: marketPlaceFunctionReducer,
  formJson: formJsonReducer,
  savedTemplate: saveTem,
  contextMenuv2:contextMenuReducerv2,
  saveLoadedSegmentId: saveLoadedSegmentId,
  saveLoadedWizardStepsId: saveLoadedWizardStepsId,
  tars: tarsReducer,
  staticAssets: staticAssetReducer,
  i18n: I18N,
  onboarding: onboardingReducer,
  widgetId: widgetIdReducer,
})


export const rootReducer = (state: any, action: any) => {
  if (action.type === "LOG_OUT") {
    // uiState should not be removed from localstorage
    state = { uiState: state.uiState };
  }
  return appReducer(state, action);
};

export type AppState = ReturnType<typeof rootReducer>;
export type RootState = ReturnType<typeof appReducer>;
